import React from "react";

import { favoritesEnabled } from "../../config";
import moment from "moment";

import GridItem from "../../partials/gridItem";
import FavouriteBtn from "../../partials/favouriteBtn";
import ShareBtn from "../../partials/shareBtn";
import { useNavigate } from "react-router-dom";

export default function BlogItem(props) {
  const navigate = useNavigate();
  const timestamp = moment(props.item.date) / 1000;

  return (
    <GridItem
      xs={12}
      sm={6}
      md={3}
      itemClass="blog"
      nid={props.item.id}
      title={props.item.title.rendered}
      bundle={props.item?.bundle}
      field_body={
        props.item.excerpt.rendered
          ? props.item.excerpt.rendered
          : props.item.content.rendered
      }
      category_label={props.categoryName}
      created={timestamp}
      hasImg={true}
      imageRatio={"free"}
      imgSrc={`${props.item._embedded["wp:featuredmedia"][0]["source_url"]}`}
      cardActionArea={true}
      cardActionCallBack={() => navigate(`/blogs/${props.item?.id}`)}
      cardActions={true}
    >
      <ShareBtn
        className="share-col ps-0"
        id={props.item.id}
        title={props.item.title.rendered}
        route={"blogs"}
        sharePrompt={`This is a public link that enables you to share the blog with your client, no login required.`}
      />
      {favoritesEnabled && (
        <FavouriteBtn
          contentType={props.contentType}
          id={parseInt(props.item.id)}
          title={props.item.title.rendered}
          thumbnail={
            props.item._embedded?.["wp:featuredmedia"]?.[0]?.["source_url"]
          }
        />
      )}
    </GridItem>
  );
}
